module.exports = __webpack_public_path__ + "static/img/loader.2f39dac0.svg";